import { MapPin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const areas = [
  "Washington, DC",
  "Bethesda, MD",
  "Silver Spring, MD",
  "Rockville, MD",
  "Gaithersburg, MD",
  "Frederick, MD",
  "Alexandria, VA",
  "Arlington, VA",
  "Falls Church, VA",
  "Fairfax, VA",
  "Reston, VA",
  "Tysons, VA",
];

export default function ServiceArea() {
  const { settings } = useSettings();

  return (
    <section id="area" className="relative py-24 lg:py-32 bg-[#050505] overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1617581629397-a72507c3de9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHx3YXNoaW5ndG9uJTIwZGMlMjBza3lsaW5lfGVufDB8fHx8MTc4Mzk4NjA4NXww&ixlib=rb-4.1.0&q=85"
          alt="Washington DC"
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <div className="text-xs uppercase tracking-[0.28em] text-yellow-400 font-bold mb-4">
            Where We Work
          </div>
          <h2 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] mb-6">
            Serving the entire<br /><span className="text-yellow-400">DMV</span> region.
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-lg">
            {settings?.service_area || "DC • Maryland • Virginia (DMV)"} — from Frederick to Fairfax, we cover it all with same-week scheduling for most jobs.
          </p>
          <div className="inline-flex items-center gap-2 border border-yellow-400/30 bg-yellow-400/5 rounded-full px-4 py-2">
            <MapPin className="w-4 h-4 text-yellow-400" />
            <span className="text-sm text-white/80">Not sure if we serve your area? Just call.</span>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
            {areas.map((a) => (
              <div
                key={a}
                data-testid={`area-${a.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`}
                className="border border-white/10 rounded-md px-4 py-3 text-sm text-white/70 hover:border-yellow-400/50 hover:text-yellow-400 hover:bg-white/[0.03] transition-all cursor-default flex items-center gap-2"
              >
                <div className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                {a}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
